export default {
  // 列表页
  '宣传页配置': '宣传页配置',
  '类型': '类型',
  '全部': '全部',
  '线上赛': '线上赛',
  '组织测试': '组织测试',
  '运动会': '运动会',
  '视频': '视频',
  '图片': '图片',
  '链接': '链接',
  '发布时间': '发布时间',
  '状态': '状态',
  '搜索': '搜索',
  '请输入标题搜索': '请输入标题搜索',
  '查询': '查询',
  '重置': '重置',
  '新增': '新增',
  '标题': '标题',
  '预览图': '预览图',
  '关联对象': '关联对象',
  '排序': '排序',
  '创建人': '创建人',
  '创建时间': '创建时间',
  '发布人': '发布人',
  '暂无图片': '暂无图片',
  '操作': '操作',
  '编辑': '编辑',
  '删除': '删除',
  '启用': '启用',
  '停用': '停用',
  '确认要停用': '确认要停用',
  '确认要停用{name}': '确认要停用{name}',
  '确认要删除': '确认要删除',
  '确认要删除{name}吗？': '确认要删除{name}吗？',
  '吗？': '吗？',
  '删除成功！': '删除成功！',
  '知道了': '知道了',
  '本机构资源空间已不足，请及时联系运营人员': '本机构资源空间已不足，请及时联系运营人员',

  // 新增/编辑页
  '基本信息': '基本信息',
  '请输入标题': '请输入标题',
  '请选择类型': '请选择类型',
  '请选择关联对象': '请选择关联对象',
  '内容设置': '内容设置',
  '封面图': '封面图',
  '支持jpg_jpeg_png格式，建议比例为16：9，最大不超过5M': '支持jpg/jpeg/png格式，建议比例为16：9，最大不超过5M',
  '视频列表': '视频列表',
  '支持mp4格式，最多上传5个视频': '支持MP4/AVI/WMV格式，建议比例为16：9，最大不超过500M，最多5个',
  '图片列表': '图片列表',
  '支持jpg_jpeg_png格式，建议比例为16：9，最大不超过20M，最多10张': '支持jpg/jpeg/png格式，建议比例为16：9，最大不超过20M，最多10张',
  '链接地址': '链接地址',
  '请输入链接地址': '请输入链接地址',
  '请输入可用链接': '请输入可用链接',
  '发布设置': '发布设置',
  '请输入排序': '请输入排序',
  '发布': '发布',
  '返回': '返回',
  '是否返回上一页？': '是否返回上一页？',
  '编辑成功': '编辑成功',
  '新增成功': '新增成功',
  '加载数据失败：': '加载数据失败：',
  '请上传封面图': '请上传封面图',
  '请上传视频': '请上传视频',
  '请上传图片': '请上传图片',
}
